// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2CscI","calendarButtons":"ClockData_calendarButtons__2FHRQ"};